import React from 'react';
import { compose, contains, is} from 'ramda';
import { RichText, Button, Image } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './Standar.js';

const TimeoutModalStandar = props => {
  const { classes } = props.theme.styles;
  const { hotelInfo, reload, idBtnsModal } = props
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const showSelectionByGroup = (!hotel || contains(hotel.get('group'), ['eurostarshotels', 'exehotels']));
  return (
      <div className={classes.timeoutModalTable}>
          <div className={classes.timeoutModalTableCell}>
            <div className={classes.timeoutModalWhite}>
                <Image svg={'sessionOut'} />
                <RichText innerStyle={classes.timeoutModalTitle} text={'_%cierre de sesión%_'} translate={true} />
                    <React.Fragment>
                    <RichText
                        innerStyle={classes.timeoutModalInfo}
                        text={
                        '_%has estado inactivo/a durante más de 20 minutos. Por favor, actualiza la página para poder seguir con la reserva. Sentimos las molestias.%_'
                        }
                        translate={true}
                        ucFirst={true}
                    />
                    {showSelectionByGroup && (<RichText
                        innerStyle={classes.timeoutModalInfo}
                        text={'_%en caso que tengas cualquier duda puedes llamarnos al tel%_'}
                        translate={true}
                        ucFirst={true}
                    />)}
                    </React.Fragment>
                <div className={classes.timeoutModalButton}>
                <Button
                    innerStyle={['buttonStyleTimeout']}
                    onClick={reload}
                    richText={{
                    text: '_%aceptar%_',
                    innerStyle: [classes.buttonTextStyle, 'uppercase'],
                    translate: true
                    }}
                    id={idBtnsModal.idCloseIcon}
                />
                </div>
            </div>
          </div>
      </div>
    );
}
TimeoutModalStandar.displayName = "TimeoutModalStandar";

export default compose(
  withThemeJSS({ styleFile, link: true  })
)(TimeoutModalStandar);